import { render } from "./PublicationCard.vue?vue&type=template&id=5ee0394a&scoped=true"
import script from "./PublicationCard.vue?vue&type=script&lang=js"
export * from "./PublicationCard.vue?vue&type=script&lang=js"

import "./PublicationCard.vue?vue&type=style&index=0&id=5ee0394a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ee0394a"]])

export default __exports__